// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Forall = (function () {
    function Forall(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Forall.create = function (value0) {
        return function (value1) {
            return new Forall(value0, value1);
        };
    };
    return Forall;
})();
var showScheme = new Data_Show.Show(function (v) {
    if (v.value0.length === 0) {
        return Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value1);
    };
    return "forall" + (Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(Data_Functor.mapFlipped(Data_Functor.functorArray)(v.value0)(function (v1) {
        return " " + v1;
    })) + (". " + Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value1)));
});
var fromType = Forall.create([  ]);
var eqScheme = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_Eq.eqArray(Lunarbox_Data_Dataflow_Type.eqTVarName))(x.value0)(y.value0) && Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(x.value1)(y.value1);
    };
});
module.exports = {
    Forall: Forall,
    fromType: fromType,
    eqScheme: eqScheme,
    showScheme: showScheme
};
